function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#575D7C",
  d: "M9.818 7.045V18.39c0 1.821-1.231 3.48-3.016 3.845-2.454.503-4.62-1.368-4.62-3.735V4.987c0-1.087.74-2.097 1.812-2.275 1.366-.226 2.551.827 2.551 2.151v11.455c0 .301-.245.545-.545.545-.3 0-.545-.244-.545-.545V7.045c0-.602-.49-1.09-1.091-1.09-.603 0-1.091.488-1.091 1.09v9.113c0 1.427 1.024 2.73 2.443 2.873 1.631.166 3.011-1.116 3.011-2.713V5.058C8.727 2.78 7.066.742 4.8.522 2.197.269 0 2.314 0 4.863v13.37c0 3.132 2.283 5.933 5.399 6.237C8.976 24.82 12 22.006 12 18.5V7.045c0-.602-.489-1.09-1.09-1.09-.603 0-1.092.488-1.092 1.09z"
});

var SvgAttach = function SvgAttach(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttach, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attach.2be3004f.svg";
export { ForwardRef as ReactComponent };